import ReportsApi from '../../apis/Reports';

export default {
    namespaced: true,
    state: {
        products: [],
        file_name: null,
        paginated:{}
    },
    mutations: {
        set_products (state, data) {
            state.products = data;
        },
        set_file_name (state, value) {
            state.file_name = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        setProducts ({ commit }, data) {
            commit('set_products', data);
        },
        async getSoldProducts({commit, dispatch}, filters) {
            commit('set_products', []);
            return await ReportsApi.getSoldProductsListPaginated(filters)
                .then( response => {
                    commit('set_paginated', {
                        ...response.data
                    })
                    commit('set_products', response.data.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar productos vendidos, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async downloadSoldProducts({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ReportsApi.downloadSoldProducts(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de productos vendidos, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}